import React, { useState } from 'react';
import { Stack } from '@mui/material';

import { FieldArray } from 'formik';
import { FoodPartnerOrderStatusEnum } from '../../../../../../core/enums/inventory/food_partner_order';
import DestinationCard from "./destination_card";

const DestinationsList = ({
                              form,
                              formik,
                              disableForm,
                              withExpirationDate,
                              foodPartnerOrderType,
                              foodPartnerOrderStatus
                          }) => {
    const disabled = foodPartnerOrderType === 'RESERVATION' || disableForm || [FoodPartnerOrderStatusEnum.DELIVERED.value, FoodPartnerOrderStatusEnum.CANCELLED.value, FoodPartnerOrderStatusEnum.COMPLETED.value].includes(foodPartnerOrderStatus);
    const disabledPrice = disableForm || [FoodPartnerOrderStatusEnum.CANCELLED.value, FoodPartnerOrderStatusEnum.COMPLETED.value].includes(foodPartnerOrderStatus);

    const [productClipboard, setProductClipboard] = useState([]);

    const onRemoveDestination = (formik, position) => {
        const destinationsList = formik?.values?.destinationsList;
        const productsList = formik?.values?.productsList;
        const index = destinationsList?.findIndex(destination => destination?.position === position);

        if (index !== -1) {
            const lastIndex = destinationsList?.length - 1;

            destinationsList?.filter(destination => destination?.position > position)
                ?.forEach(destination => {
                    productsList[destination?.position - 1] = productsList[destination?.position] || [];
                    destinationsList[destination?.position - 1] = {
                        ...destination,
                        position: destination?.position - 1
                    };
                });

            destinationsList.splice(lastIndex, 1);
            productsList.splice(lastIndex, 1);

            formik.setFieldValue(`destinationsList`, destinationsList);
            formik.setFieldValue(`productsList`, productsList);
        }
    };

    const copyProductsToClipboard = (formik, index) => {
        setProductClipboard(formik?.values?.productsList[index]?.slice() || []);
    };

    const pasteProductsFromClipboard = (formik, index) => {
        formik.setFieldValue(`productsList.${ index }`, productClipboard.slice());
    };

    return (
        <FieldArray
            name={ `destinationsList` }
            render={ () => (
                <Stack spacing={ 3 }>
                    {
                        formik?.values?.destinationsList?.map((destination, index) => (
                            <DestinationCard
                                key={ destination.position }
                                destination={ destination }
                                form={ form }
                                formik={ formik }
                                index={ index }
                                withExpirationDate={ withExpirationDate }
                                disabled={ disabled }
                                disabledPrice={ disabledPrice }
                                copyProductsToClipboard={ copyProductsToClipboard }
                                pasteProductsFromClipboard={ pasteProductsFromClipboard }
                                showPasteFromClipboard={ productClipboard.length > 0 }
                                onRemoveDestination={ onRemoveDestination }
                            />
                        ))
                    }
                </Stack>
            ) }
        />
    );
};

export default DestinationsList;